var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinked(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_492_4",
    "data-name": "Component 492 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.711,
    height: 15.421,
    viewBox: "0 0 7.711 15.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61982",
    "data-name": "Path 61982",
    d: "M3.465,10.855a2.392,2.392,0,0,1,2.39-2.39H8.94V7H5.855a3.855,3.855,0,0,0,0,7.711H8.94V13.246H5.855A2.392,2.392,0,0,1,3.465,10.855Zm3.161.771h6.168V10.084H6.626ZM13.566,7H10.482V8.465h3.084a2.39,2.39,0,0,1,0,4.781H10.482v1.465h3.084a3.855,3.855,0,0,0,0-7.711Z",
    transform: "translate(-7 17.421) rotate(-90)",
    fill: "#828282"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/Linked.803410d10523d30818501b77b9d150f1.svg";
export { ForwardRef as ReactComponent };